define('SiteSearch.Common', [
    'SiteSearch.RemoveFocus'
],
function SiteSearchCommon(

) {
    'use strict';

    return {};
});

